import { createApp } from 'vue';
import App from './app.vue'

import 'leaflet/dist/leaflet.css';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

import { i18n } from './locale';
import { router } from './router';

const app = createApp(App)

app
.use(Antd)
.use(router)
.use(i18n)
.mount('#app')
